import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
import SortMap from '../../common/utils/SortMap';
/**
 * State class for managing the user directory list with pagination.
 * Based on Flarum's modern DiscussionListState pattern.
 */
export default class UserDirectoryListState extends PaginatedListState {
  constructor(params, page) {
    if (params === void 0) {
      params = {};
    }
    if (page === void 0) {
      page = 1;
    }
    super(params, page, null);
    _defineProperty(this, "qBuilder", {});
  }
  get type() {
    return 'users';
  }
  requestParams() {
    const params = {
      include: ['groups'],
      filter: this.params.filter || {}
    };
    const sortKey = this.params.sort || app.forum.attribute('userDirectoryDefaultSort');
    const sortValue = this.sortMap()[sortKey];
    params.sort = typeof sortValue === 'string' ? sortValue : sortValue?.sort;
    if (this.params.q) {
      if (!params.filter) {
        params.filter = {};
      }
      params.filter.q = this.params.q;
    }
    return params;
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedUsers = app.preloadedApiDocument();
    if (preloadedUsers) {
      this.initialLoading = false;
      this.pageSize = preloadedUsers.payload.meta?.perPage || UserDirectoryListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloadedUsers);
    }
    return super.loadPage(page);
  }

  /**
   * Get the sort map for the user directory.
   *
   * **Note for extension developers**: Do NOT extend this method.
   * Instead, extend the `SortMap` class from `common/utils/SortMap`:
   *
   * @example
   * import { extend } from 'flarum/common/extend';
   * import SortMap from 'ext:fof/user-directory/common/utils/SortMap';
   *
   * extend(SortMap.prototype, 'sortMap', function (map) {
   *   map.my_custom_sort = '-customField';
   * });
   */
  sortMap() {
    return {
      default: '',
      ...new SortMap().sortMap()
    };
  }

  /**
   * Update parameters and refresh the list.
   * Handles qBuilder logic for building query strings from filters.
   */
  refreshParams(newParams, page) {
    if (page === void 0) {
      page = 1;
    }
    // Process qBuilder if provided
    if (newParams.qBuilder) {
      Object.assign(this.qBuilder, newParams.qBuilder || {});
      newParams.q = Object.values(this.qBuilder).join(' ').trim();
    }

    // Ensure q is a string
    if (!newParams.q) {
      newParams.q = '';
    } else if (typeof newParams.q !== 'string') {
      newParams.q = String(newParams.q);
    }
    return super.refreshParams(newParams, page);
  }
}
flarum.reg.add('fof-user-directory', 'forum/states/UserDirectoryListState', UserDirectoryListState);